import React from 'react';
import Header from "../../Layouts/Header";
import Navbar from "../../Layouts/Navbar";

import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import {useNavigate} from "react-router-dom";
import {RiListCheck3} from "react-icons/ri";
import "react-multi-date-picker/styles/layouts/mobile.css"


function Vendors() {

    const navigate = useNavigate();

    const [isLoaded, setIsLoaded] = React.useState(false);
    const [vendors, setVendors] = React.useState([]);


    const [search, setSearch] = React.useState( null);


    React.useEffect(() => {
        const params = {
            list: 1,
            orderBy: 'created_at',
            orderType: 'asc',
            search,
            count: 200,
        }
        API.getVendors(params)
            .then((response) => {
                setVendors(response.data);
                setIsLoaded(true)
            })
            .catch((error) => {
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });
    }, [search]);



    return (
        <React.Fragment>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }
            <Header/>
            <Navbar page="vendors"/>

            <main id="main" className="main rtl">

                <div className="pagetitle mb-5 border-bottom pb-4">
                    <h1>
                        <RiListCheck3 className='ms-2' />
مدیریت نمایندگان
                    </h1>

                </div>

                <section className="section">
                    <div className="row">
                        <div className="col-12">

                            <div className="card">
                                <div className="card-body pt-4">


                                    <div className="form-floating mb-3">
                                        <input type="email" className="form-control" id="floatingInput" placeholder="جستجو"
                                        value={search}
                                               onChange={(ev) => {
                                                   setSearch(ev.target.value)
                                               }}
                                        />
                                            <label htmlFor="floatingInput">جستجوی نماینده</label>
                                    </div>

                                    <table className="table table-responsive">
                                        <thead>
                                        <tr className='text-small-2 text-muted'>
                                            <th scope="col"># </th>
                                            <th scope="col">عنوان</th>
                                            <th scope="col">شهر</th>
                                            <th scope="col">کد تفصیل</th>
                                            <th scope="col"> کد سامانه تجارت</th>

                                        </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            vendors.map ((vendor,index) => {
                                                return (
                                                    <tr  key={vendor.id}
                                                         role='button'
                                                         onClick={() => navigate(`/vendors/${vendor.id}`)}
                                                    >
                                                        <th scope="row">
                                                            {index + 1}
                                                        </th>
                                                        <td>
                                                            {vendor.title}
                                                            {
                                                                vendor.is_tropical ?
                                                                    <span className='badge text-bg-warning mx-2 p-2'> گرمسیری</span>
                                                                    : ""
                                                            }
                                                            {
                                                                vendor.is_car_producer ?
                                                                    <span className='badge bg-secondary-subtle mx-2 p-2'> خودروساز</span>
                                                                    : ""
                                                            }
                                                        </td>
                                                        <td>
                                                            {vendor.city}
                                                        </td>
                                                        <td>
                                                            {vendor.code}
                                                        </td>
                                                        <td  >
                                                            {vendor.trade_system_code}
                                                        </td>

                                                    </tr>
                                                )} )
                                        }
                                        </tbody>
                                    </table>


                                </div>
                            </div>

                        </div>



                    </div>
                </section>

            </main>

        </React.Fragment>
    );
}

export default Vendors;